import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import accessDeniedImg from '../../../Assets/401-unauthorized.svg';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            position: 'relative',
            textAlign: 'center',
        },
        img: {
            width: '30%',
        },
        paragraphSorry: {
            fontSize: '60px',
            marginTop: '0px',
            // marginLeft:"12%",
            marginBottom: '13px',
            fontFamily: 'serif',
        },
    }),
);

const AccessDenied = () => {
    const styles = useStyles();
    return (
        <>
            <div className={styles.container}>
                <img className={styles.img} src={accessDeniedImg} alt="Access denied" />
                <div>
                    <p className={styles.paragraphSorry}>
                        <b> Access denied!</b>
                    </p>
                </div>
            </div>
        </>
    );
};

export default AccessDenied;
